import { render, staticRenderFns } from "./workAssignments.vue?vue&type=template&id=237e667a&scoped=true"
import script from "./workAssignments.vue?vue&type=script&lang=js"
export * from "./workAssignments.vue?vue&type=script&lang=js"
import style0 from "./workAssignments.vue?vue&type=style&index=0&id=237e667a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237e667a",
  null
  
)

export default component.exports